import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main.component';
import { AuthGuardMain } from '../auth/auth-guard.service';


const routes: Routes = [
  {
    path: "main",
    component: MainComponent,
    canActivate: [AuthGuardMain],
    children: [
      { path: "", redirectTo: "/main/dashboard", pathMatch: "full" },
      { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)},
      { path: 'scoober', loadChildren: () => import('./scoober/scoober.module').then(m => m.ScooberModule)},
      { path: 'reward', loadChildren: () => import('./reward/reward.module').then(m => m.RewardModule)},
      { path: 'ride', loadChildren: () => import('./rides/rides.module').then(m => m.RidesModule)},
      { path: 'user-management', loadChildren: () => import('../main/user-management/user-management.module').then(m => m.UserManagementModule)},
      { path: 'setting', loadChildren: () => import('../main/setting-management/setting-management.module').then(m => m.SettingManagementModule)},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule { }
